import * as O from 'fp-ts/Option';
import * as Configuration from './configuration';
import * as Product from './product';
import * as Api from '../api';
import { constant, identity, pipe } from 'fp-ts/lib/function';
export const price = (good) => {
    if (Configuration.Product.is(good)) {
        return O.some(Product.price(Configuration.Product.product(good)));
    }
    else if (Configuration.NullProduct.is(good)) {
        return O.none;
    }
    else {
        return O.some(Product.price(good));
    }
};
export const id = (good) => Configuration.Product.is(good)
    ? O.some(Product.id(Configuration.Product.product(good)))
    : Configuration.NullProduct.is(good)
        ? O.none
        : O.some(Product.id(good));
export const imageForPart = (good) => {
    if (Product.is(good)) {
        return O.some(Product.image(good));
    }
    else if (Configuration.Product.is(good)) {
        return O.some(Product.image(Configuration.Product.product(good)));
    }
    else {
        return O.none;
    }
};
export const nameForPart = (good) => {
    if (Product.is(good)) {
        return O.some(Product.name(good));
    }
    else if (Configuration.Product.is(good)) {
        return O.some(Product.name(Configuration.Product.product(good)));
    }
    else {
        return O.none;
    }
};
export const properties = (good) => {
    if (Product.is(good)) {
        return Product.properties(good);
    }
    else if (Configuration.Product.is(good)) {
        return Product.properties(Configuration.Product.product(good));
    }
    else {
        return {};
    }
};
export const productUrl = (good) => Configuration.Product.is(good)
    ? O.some(Product.productUrl(Configuration.Product.product(good)))
    : Configuration.NullProduct.is(good)
        ? O.none
        : O.some(Product.productUrl(good));
export const compareProperties = (goodA, goodB) => {
    return Api.Product.Property.compare(properties(goodA), properties(goodB));
};
/** Useful for fp-ts operations */
export const EqGood = {
    equals(x, y) {
        return pipe(O.Do, O.bind('xId', () => id(x)), O.bind('yId', () => id(y)), O.map(({ xId, yId }) => xId === yId), O.match(constant(false), identity));
    },
};
export const equals = EqGood.equals;
export const fromProduct = (product) => product;
